import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  mainBox: {
    zIndex: "1",
    minHeight: "618.54px",
    display: "flex",
    justifyContent: "center",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "@media(max-width:991px)": {
      minHeight: "514.54px",
      backgroundPosition: " -38px 1px",
    },
    "@media(max-width:1024px)": {
      minHeight: "411.54px",
    },
  },
}));

const BannerMenu = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Box className={classes.mainBox}>
      <Box class="main-navigation">
        <Box className="bgImagecir">
          <img
            src="images/banner/bgCircular_2.png"
            className="bgcircular bgx2"
            alt=" "
          />
        </Box>
        <Box className="bgImagecir">
          <img
            src="images/banner/banner_text.png"
            className="bgcircular bgx1"
            alt=" "
          />
        </Box>
        <Box className="bgImagecir">
          <img
            src="images/banner/bgCircular_22.png"
            className="bgcircular "
            alt=" "
          />
        </Box>
        {/* <Box className="bgImagecir">
          <img
            src="images/banner/bgCircular5.png"
            className="bgcircular bgx2"
            alt=" "
          />
        </Box> */}
        <Box className="bgImagecir">
          <img
            src="images/banner/bgCircular_6.png"
            className="bgcircular bgx1"
            alt=" "
          />
        </Box>
        <Box className="bgImagecir">
          <img
            src="images/banner/bgCircular_1.png"
            className="bgcircular star"
            alt=" "
          />
        </Box>
      </Box>
    </Box>
  );
};

export default BannerMenu;
